import {
  Box,
  Button,
  ButtonGroup,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { File } from "react-pdf/dist/shared/types";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const options = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
  wasmUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/wasm/`,
};

const PDFViewer = ({ file }: { file?: File }) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const lastScrollY = useRef(0);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
    setPageNumber(1);
    setLoading(false);
  }

  function changePage(offset: number) {
    if (scrollContainerRef.current) {
      lastScrollY.current = scrollContainerRef.current.scrollTop;
    }
    setPageNumber((prev) => prev + offset);
  }

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTop = lastScrollY.current;
    }
  }, [pageNumber]);

  return (
    <Box
      ref={scrollContainerRef}
      sx={{
        overflowY: "auto",
        p: 2,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<CircularProgress />}
        options={options}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Page
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={scrollContainerRef.current?.clientWidth || 600}
          />
        </Box>
      </Document>

      {!loading && (
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Typography mb={1}>
            Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
          </Typography>
          <ButtonGroup variant="outlined">
            <Button disabled={pageNumber <= 1} onClick={() => changePage(-1)}>
              Previous
            </Button>
            <Button
              disabled={pageNumber >= numPages}
              onClick={() => changePage(1)}
            >
              Next
            </Button>
          </ButtonGroup>
        </Box>
      )}
    </Box>
  );
};

export default PDFViewer;
